import React from 'react';
import Sidebar from '../Sidebar';
import Dashboard from '../Dashboard';
import TransactionsMain from './TransactionsMain'

export default function Transactions() {
    return (
        <div>
            <Dashboard cmp={<TransactionsMain />} />
        </div>
    )
}

